import { StringConst } from 'src/app/constants/const';

export class ReportPhotoProfile {
    reportUserName: string;
    profilePicture: string;
    pictureFormat: string;

    constructor() {
        this.reportUserName = StringConst.empty;
        this.profilePicture = StringConst.empty;
        this.pictureFormat = StringConst.empty;
    }
}
export class PromotionPhotoProfile {
    adminUserName: string;
    profilePicture: string;
    pictureFormat: string;
    constructor() {
        this.adminUserName = StringConst.empty;
        this.profilePicture = StringConst.empty;
        this.pictureFormat = StringConst.empty;
    }
}
